import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useWorkplacePhysicianCompanyList() {
  // Use toast
  const toast = useToast()

  const refInstitutionListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'institution.name', label: 'Instituição', sortable: true },
    { key: 'physician_company.name', label: 'Empresa' },
    { key: 'physician.name', label: 'Profissional' },
    { key: 'workplace.name', label: 'Unidade' },
    { key: 'status', label: 'Status', sortable: false },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(50)
  const totalInstitutions = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100, 200, 300]
  const searchQuery = ref('')
  const sortBy = ref('institution.name')
  const isSortDirDesc = ref(false)
  const institutionFilter = ref(null)
  const workplaceFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refInstitutionListTable.value ? refInstitutionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInstitutions.value,
    }
  })

  const refetchData = () => {
    refInstitutionListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  const fetchItems = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value ? 'desc' : 'asc',
      institution: institutionFilter.value || '',
      workplace: workplaceFilter.value || '',
    }
    store
      .dispatch('app-reports/workplacePhysicianCompanyPending', params)
      .then(response => {
        const { data, meta } = response.data
        callback(data)
        totalInstitutions.value = meta.pagination.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao buscar',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const getStatusLabelModal = status => {
    if (status === 'approved') return 'Aprovar'
    if (status === 'denied') return 'Recusar'
    return 'Pendente'
  }

  const resolvePhysicianStatusLabel = status => {
    if (status === 'denied') {
      return 'Recusado'
    }
    return status === 'approved' ? 'Aprovado' : 'Pendente'
  }

  const resolveStatusVariant = status => {
    if (status === 'approved') return 'success'
    if (status === 'pending') return 'secondary'
    return 'danger'
  }

  return {
    resolvePhysicianStatusLabel,
    resolveStatusVariant,
    fetchItems,
    tableColumns,
    perPage,
    currentPage,
    totalInstitutions,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refInstitutionListTable,
    refetchData,
    // Extra Filters
    institutionFilter,
    workplaceFilter,
    statusFilter,
    getStatusLabelModal,
  }
}
